module.exports = __webpack_public_path__ + "media/images/Group 4-59c9e2928d03a60221ac53f870e250f3.svg";